import * as React from 'react';
import Header from 'components/header/header';
import Icon from 'components/icon/icon';
import Logo from 'components/logo/logo';
import Button from 'components/button/button';
import useMediaQuery, { MediaQueryWidth } from 'lib/use-media-query';
import { useMenu } from 'components/menu/use-menu';
import { Menu } from 'interfaces/microsite-cms';

type Props = {
    menuAction?: boolean;
    extraClass?: string;
    logoUrl?: string;
    menu?: Menu;
};

export function PageHeader({ menuAction = true, extraClass, logoUrl, menu }: Props) {
    const isBreakpoint = useMediaQuery(MediaQueryWidth['tablet-md']);
    const isBreakpointDesktop = useMediaQuery(MediaQueryWidth['desktop-md']);
    const onOpenMenu = React.useCallback(() => {
        global.document.body.classList.toggle('is-opened-mobile-nav');
        // This is super crappy but need to leave it as is for now
        const selector = global.document.querySelector('.js-mobile-navigation');

        if (selector) {
            selector.classList.toggle('is-active');
        }
    }, []);

    const menuList = useMenu({ menu }).map(
        (menuItem: any) =>
            menuItem.text &&
            menuItem.uri && (
                <Button
                    size={Button.size.EXTRA_LARGE}
                    labelText={menuItem.text}
                    color={Button.color.Primary}
                    designType={Button.designType.FILLED}
                    extraClass="button--footer-cta button--color-primary button--bold"
                    href={menuItem.uri}
                    text={menuItem.text}
                    seo={menuItem.seo}
                    onClick={menuItem.onClick}
                    key={menuItem.id}
                />
            )
    );

    return (
        <Header
            extraClass={isBreakpoint ? extraClass : `has-actions-v-aligned ${extraClass || ''}`}
            logo={<Logo />}
            logoUrl={logoUrl}
            actionMobilePanel={
                isBreakpointDesktop && menuAction ? (
                    //@todo - https://jira.badoojira.com/browse/LOC-5433
                    <Button
                        labelText="Open Menu"
                        isCircle={true}
                        icon={<Icon size="md" name={Icon.Name.Menu} color="primary-black" />}
                        onClick={onOpenMenu}
                    />
                ) : null
            }
            actions={isBreakpointDesktop ? undefined : menuList}
        />
    );
}
